module.exports = __webpack_public_path__ + "static/media/FriendFinder03.b493950c.png";